import { isErrorWithStatus } from '.';

export const isEmailTakenError = isErrorWithStatus( 400, 'invalid_email' );
export const isNoAccessCodeError = isErrorWithStatus( 422, 'unprocessable_code' );
export const isInvalidAccessCodeError = isErrorWithStatus( 400, 'invalid_code' );
export const isUserNotFoundError = isErrorWithStatus( 404, 'not_found' );
export const isUnprocessableCredentialsError = isErrorWithStatus( 422, 'unprocessable_credentials' );
